import { CreateData } from '../config/createData';
import { HOST_API } from '../config/hosts';

import { login } from '../redux/actions';
import store from '../redux/store';
import api from './api';

export default class Auth {
  constructor(username, password) {
    this.username = username;
    this.password = password;
    this.response = {};
  }

  // Realizando o login:
  async login() {
    const payload = CreateData.payloadLogin(this.username, this.password);

    try {
      this.response = await api.post(`${HOST_API}/v1/login/authenticate`, payload);

      return {
        data: this.response.data?.data,
        status: this.response.status,
      };
    } catch (error) {
      const statusError = error.response?.status;

      return {
        status: statusError,
        data: null,
      };
    }
  }

  // Realizando o armazenamento dos dados na store (Redux):
  async store() {
    try {
      const currentData = this.response.data;
      store.dispatch(login(currentData));
      return {
        status: 200,
      };
    } catch (e) {
      return {
        status: 403,
      };
    }
  }

  // Realizar o login automático com o token armazenado em cache:
  async automaticLogin(payload) {
    try {
      const response = await api.get(`/v1/auth`);

      const userData = response?.data;
      this.response = {
        data: {
          ...userData,
          token: payload.token,
        },
      };
      this.store();

      return {
        status: 200,
      };
    } catch (e) {
      return {
        status: 400,
      };
    }
  }

  async updatePassword(payload) {
    try {
      const response = await api.patch(`/v1/auth/password`, {
        password: payload.password,
        new_password: payload.new_password,
        isFirstAccess: false,
      });

      return {
        status: 200,
      };
    } catch (e) {
      return {
        status: 400,
      };
    }
  }
}
